
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/premium-themes/paperbase",
      function () {
        return require("private-next-pages/premium-themes/paperbase/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/premium-themes/paperbase"])
      });
    }
  